export default __webpack_public_path__ + "static/media/bg_desc_big_food.dd49e9c8.jpg";